module.exports = __webpack_public_path__ + "img/4.6f766f2d.png";